<template>
  <v-card>
    <v-container>
      <v-row no-gutters>
        <v-col offset="3" cols="9">Settings</v-col>
        <v-col offset="3" cols="4" class="pt-2">
          <v-text-field label="User" outlined dense></v-text-field>
        </v-col>
        <v-col offset="3" cols="4" class="pt-1">
          <v-text-field label="Branch" outlined dense></v-text-field>
        </v-col>
        <v-col offset="3" cols="4">
          <v-checkbox v-model="selected" hide-details label="Complete Report" value="Complete"></v-checkbox>
          <v-checkbox v-model="selected" hide-details label="Sale Report" value="Sale"></v-checkbox>
          <v-checkbox v-model="selected" hide-details label="Advance Paid Report" value="Advance Paid"></v-checkbox>
          <v-checkbox v-model="selected" hide-details label="Income Report" value="Income"></v-checkbox>
          <v-checkbox v-model="selected" hide-details label="Expense Report" value="Expense"></v-checkbox>
          <v-checkbox v-model="selected" hide-details label="Profit and Loss Report" value="ProfitandLoss"></v-checkbox>
          <p>{{ selected }}</p>
        </v-col>
        <v-col offset="3" cols="4" class="pt-1">
          <v-btn class="ma-1" depressed color="primary">Save</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>
<script>
export default {
  data() {
    return {
      selected: [],
    };
  },
};
</script>